<template>
  <div>
    <div id="north">
      <header-info cur="1"></header-info>
    </div>
    <div class="list">
      <ul>
        <li
          :class="isActive==1?'on':''"
          @click="isActive=1"
        >预习内容</li>
        <li
          :class="isActive==2?'on':''"
          @click="isActive=2"
        >学习内容</li>
        <li
          :class="isActive==3?'on':''"
          @click="isActive=3"
        >测试内容</li>
      </ul>

      <div
        class="mobile mobile-item"
        v-show="isActive==1"
      >
        <ul
          class="field-column"
          v-if="listData.length"
        >
          <div
            v-for="(item, index) in listData"
            :key="index"
          >
            <li
              class="field-item"
              v-if="item.preview==0"
            >
              <img
                :src="FunIcont(item)"
                alt=""
              >
              <span class="name">{{item.title?item.title:item.experiment.title}}</span>
              <span
                class="view"
                v-if="!item.studyType"
                @click="viewResource(item.path)"
              >点击查看</span>
            </li>
          </div>
        </ul>
      </div>
      <div
        class="mobile mobile-item"
        v-show="isActive==2"
      >
        <ul
          class="field-column"
          v-if="listData.length"
        >
          <div
            v-for="(item, index) in listData"
            :key="index"
          >
            <li
              class="field-item"
              v-if="item.preview==1"
            >
              <img
                :src="FunIcont(item)"
                alt=""
              >
              <span class="name">{{item.title?item.title:item.experiment.title}}</span>
              <span
                class="view"
                v-if="!item.studyType"
                @click="viewResource(item.path)"
              >点击查看</span>
            </li>
          </div>
        </ul>
      </div>
      <div
        class="mobile mobile-item"
        v-show="isActive==3 "
      >

        <div
          v-for="(item, index) in listData"
          :key="index"
        >
          <div
            class="exam"
            v-if="item.preview!=0 && item.preview!=1"
          >
            <div class="title">{{item.title}}</div>
            <div class="cont">考试说明：{{item.des}}</div>
            <div class="time">
              <span>开始时间：{{formatTime(item.startTime)}}</span>
              <span>结束时间：{{formatTime(item.endTime)}}</span>
              <span>显示成绩时间：{{formatTime(item.answerTime)}}</span>
            </div>
            <div class="tips">
              您需要在Web端完成测试，加油！
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
// 图标
import study from '../../../assets/images/lessonStudy/study.png'
import studyHover from '../../../assets/images/lessonStudy/study_hover.png'
import exp from '../../../assets/images/lessonStudy/exp.png'
import expHover from '../../../assets/images/lessonStudy/exp_hover.png'
import testImg from '../../../assets/images/lessonStudy/testImg.png'
import testImgHover from '../../../assets/images/lessonStudy/testImg_hover.png'

export default {
  name: 'StudyLesson',
  components: {
    HeaderInfo
  },
  data() {
    return {
      isActive: '1',
      studyData: [],
      examData: []

    }
  },
  mounted() {
    this.getStudy()
    this.getExam()
  },
  computed: {
    localUser() {
      return this.$store.state.userInfo
    },
    listData () {
      const data = []
      for (let i = 0; i < this.studyData.length; i++) {
        this.$set(this.studyData[i], 'type', 1)
        this.$set(this.studyData[i], 'isActive', 0)
        data.push(this.studyData[i])
      }
      for (let i = 0; i < this.examData.length; i++) {
        this.$set(this.examData[i], 'type', 2)
        this.$set(this.examData[i], 'isActive', 0)
        data.push(this.examData[i])
      }
      return data
    }
  },

  methods: {
    viewResource(val) {
      this.$router.push('/www/viewfile?path=' + val)
    },
    formatTime(val) {
      if (!val) {
        return ''
      }
      return val.replace('T', ' ')
    },
    // 获取学习信息
    async getStudy () {
      await this.$http.get('/online_study/', {
        params: { // 节
          page: 1,
          size: 10000,
          status: 1,
          lessonOnline_id: this.$route.query.id
        }
      }).then((data) => {
        const previewStudy = []
        const normalStudy = []
        for (let i = 0; i < data.results.length; i++) {
          if (data.results[i].preview === 0) {
            previewStudy.push(data.results[i])
          } else {
            normalStudy.push(data.results[i])
          }
        }
        this.studyData = previewStudy.concat(normalStudy)
      })
    },
    async getExam () {
      await this.$http.get('/online_exam/', {
        params: {
          page: 1,
          size: 10000,
          status: 1,
          lessonOnline_id: this.$route.query.id
        }
      }).then((data) => {
        this.examData = data.results
      }).catch((error) => {
        console.log(error)
      })
    },
    // 匹配对应图标
    FunIcont(item) {
      var Icont = ''
      if (item.type === 1) {
        if (item.isActive === 0) {
          Icont = item.studyType ? exp : study
        } else {
          Icont = item.studyType ? expHover : studyHover
        }
      } else if (item.type === 2) {
        Icont = item.isActive ? testImgHover : testImg
      }
      return Icont
    }
  }
}
</script>

<style lang="less" scoped>
.list > ul {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid #c9c9c9;
  li {
    line-height: 30px;
    border-bottom: 2px solid transparent;
    &.on {
      border-bottom: 2px solid #73D6CA;
    }
  }
}
.field-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
  padding-bottom: 5px;
  border-bottom: 1px solid #ede4e4;
  img {
    width: 15px;
    margin-right: 5px;
  }
  .name {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .view {
    margin-left: auto;
    color: #73D6CA;
  }
}
.exam {
  .title {
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }
  .cont {
    font-size: 14px;
    margin: 10px 0;
    color: #666;
    border-bottom: 1px solid #ede4e4;
    padding-bottom: 20px;
  }
  .time {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #666;
    border-bottom: 1px solid #ede4e4;
    padding-bottom: 20px;
    span {
      margin-bottom: 10px;
    }
  }
  .tips {
    text-align: center;
    font-size: 14px;
    margin-top: 20px;
    color: #ede4e4;
  }
}
</style>
